import { render, staticRenderFns } from "./FetchAndAddFromHostBill.vue?vue&type=template&id=b9908afe&scoped=true"
import script from "./FetchAndAddFromHostBill.vue?vue&type=script&lang=js"
export * from "./FetchAndAddFromHostBill.vue?vue&type=script&lang=js"
import style0 from "./FetchAndAddFromHostBill.vue?vue&type=style&index=0&id=b9908afe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9908afe",
  null
  
)

export default component.exports